import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Space,
  Text,
} from '@tonic-one/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const TipModal = (props: any) => {
  const { visible, onClose, onConfirm, dataList } = props;
  const { t } = useTranslation();

  const useToggle = (defaultValue: boolean) => {
    const [value, setValue] = useState(defaultValue);
    const toggle = () => setValue((value) => !value);
    return [value, toggle];
  };

  const [isOverlayVisible] = useToggle(true);

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={visible}
      onClose={onClose}
      size="sm"
    >
      {isOverlayVisible && <ModalOverlay opacity={0.9} />}
      <ModalContent minHeight="200px">
        <ModalBody>
          <Text mb="8x">
            <Text mb={8}>
              {t('administration.apiToken.add.content', {
                apiType: t(
                  'administration.apiToken.table.scopeName.mitigation'
                ),
              })}
              <br />
              {t('administration.apiToken.tip.content')}
            </Text>
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            minWidth="20x"
            onClick={() => {
              onConfirm(dataList);
            }}
          >
            {t('common.button.ok')}
          </Button>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default TipModal;
